import request from '@/utils/request'

export function getZcByCompanyName(params) {
  return request({
    url: '/system/Plan/getZcByCompanyName',
    method: 'get',
    params
  })
}

export function getByCompanyCode(params) {
  return request({
    url: '/system/Plan/getByCompanyCode',
    method: 'get',
    params
  })
}
